import { styled } from 'styled-components';
import { Typography } from '@mui/material';

export const CardTitle = styled(Typography)`
    font-size: ${({ theme }) => theme.typography.h4.fontSize};
    line-height: ${({ theme }) => theme.spacing(3)};
    margin-bottom: 3px;
    font-weight: ${({ theme }) => theme.typography.fontWeightBold};
`;
